/**
 * The windows a fleet scan can look back over, in hours, in one place so the page and the hooks
 * cannot drift.
 *
 * A scan reads every reading of the checked diagnostics the fleet sent within the window, one
 * diagnostic after another, so its cost grows with fleet size times window. It shows its progress,
 * so a long one can be watched and stopped.
 */
export const SCAN_WINDOW_OPTIONS_HOURS = [24, 72, 168] as const;

export const DEFAULT_SCAN_WINDOW_HOURS = SCAN_WINDOW_OPTIONS_HOURS[0];
